(() => {
  const GAP = 12;
  const DESKTOP = '(min-width: 750px)';

  function isRtl() {
    return document.documentElement.dir === 'rtl' || getComputedStyle(document.documentElement).direction === 'rtl';
  }

  function getTrigger() {
    return document.querySelector('header-actions .account-button') || document.querySelector('shopify-account');
  }

  function isAccountPanel(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    const text = (el.textContent || '').toLowerCase();
    return rect.width > 200 && rect.height > 100 && (text.includes('sign in') || text.includes('google') || text.includes('ההזמנות') || text.includes('הפרופיל') || text.includes('account'));
  }

  function applyPosition(panel, left) {
    panel.style.setProperty('left', `${left}px`, 'important');
    panel.style.setProperty('right', 'auto', 'important');
    panel.style.setProperty('inset-inline-start', `${left}px`, 'important');
    panel.style.setProperty('inset-inline-end', 'auto', 'important');
    panel.style.setProperty('transform-origin', 'top left', 'important');
    panel.style.setProperty('z-index', '9999', 'important');
  }

  function getLeft(trigger, panel) {
    const triggerRect = trigger.getBoundingClientRect();
    const panelRect = panel.getBoundingClientRect();
    let left = Math.round(triggerRect.left);
    return Math.max(GAP, Math.min(left, window.innerWidth - panelRect.width - GAP));
  }

  function moveDocumentPanels(trigger) {
    document.querySelectorAll('dialog, [popover], [role="dialog"]').forEach((panel) => {
      if (!isAccountPanel(panel)) return;
      applyPosition(panel, getLeft(trigger, panel));
    });
  }

  function moveShadowPanels(trigger) {
    document.querySelectorAll('shopify-account').forEach((account) => {
      account.style.setProperty('--shopify-account-dialog-position-left', '20px');
      account.style.setProperty('--shopify-account-dialog-position-right', 'auto');
      account.style.setProperty('--shopify-account-dialog-transform-origin', 'top left');

      if (!account.shadowRoot) return;

      account.shadowRoot.querySelectorAll('style[data-rtl-account-fix]').forEach((style) => style.remove());
      const style = document.createElement('style');
      style.dataset.rtlAccountFix = 'true';
      style.textContent = `
        dialog,
        [popover],
        [role='dialog'],
        .popover,
        .dialog,
        .modal {
          right: auto !important;
          left: 20px !important;
          inset-inline-end: auto !important;
          inset-inline-start: 20px !important;
          transform-origin: top left !important;
          z-index: 9999 !important;
        }
      `;
      account.shadowRoot.appendChild(style);

      account.shadowRoot.querySelectorAll('dialog, [popover], [role="dialog"], .popover, .dialog, .modal').forEach((panel) => {
        const rect = panel.getBoundingClientRect();
        if (rect.width > 200 && rect.height > 100) {
          applyPosition(panel, getLeft(trigger, panel));
        }
      });
    });
  }

  function fix() {
    if (!isRtl() || !window.matchMedia(DESKTOP).matches) return;
    const trigger = getTrigger();
    if (!trigger) return;
    moveDocumentPanels(trigger);
    moveShadowPanels(trigger);
  }

  function schedule() {
    requestAnimationFrame(fix);
    setTimeout(fix, 50);
    setTimeout(fix, 150);
    setTimeout(fix, 400);
    setTimeout(fix, 900);
  }

  document.addEventListener('click', schedule, true);
  document.addEventListener('pointerdown', schedule, true);
  document.addEventListener('toggle', schedule, true);
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open', 'popover', 'style', 'class']
  });

  schedule();
})();
